import React from 'react';
import './Payroll.css';
import { Link } from 'react-router-dom';

import Icon from '../../../components/Icon/Icon';
import DocumentLinks from '../../../components/DocumentLinks/DocumentLinks';
import CurvedBottom from '../../../components/CurvedBottom/CurvedBottom';

const payroll = ( props ) => {
	return (
		<section className="bg-color-1 hasCurve" id="Payroll">
			<h2>Payroll <span>&</span> Tax Forms</h2>
			<p className="titleNote">
				Don't let tax season destroy the delicate balance of your life
			</p>
			<Icon icon="pay.pay" />
			<div className="info-docs">
				<p>
					Do you have a life change that requires a new tax or payroll form? Or maybe your handwriting was just realllly sloppy on that first take, and you don't want to bug HR or search your email for a new one. Look no further! Tax and payroll forms are available here.
				</p>
				<DocumentLinks docs={ props.docs } />
			</div>
			<div className='below-text'>
				<p>Stuck filling out a form? Contact the <Link to='/perks-for-the-people'>HR Hero</Link>.</p>
			</div>
			<CurvedBottom />
		</section>
	);
};

export default payroll;



// WEBPACK FOOTER //
// ./src/pages/Pay/Payroll/Payroll.js